import { Field, useField } from 'formik';
import { Toggle } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
export const CommunicationIsReleaseNotesField = _ref => {
  let {
    name,
    ...stylingProps
  } = _ref;
  const [{
    value
  }] = useField(name);
  return /*#__PURE__*/_jsx(Field, {
    ...stylingProps,
    as: Toggle,
    checked: value,
    label: "Show in release notes",
    name: "isReleaseNotes",
    size: "xs",
    "data-sentry-element": "Field",
    "data-sentry-component": "CommunicationIsReleaseNotesField",
    "data-sentry-source-file": "CommunicationIsReleaseNotesField.tsx"
  });
};